import { ErrorType, LoadedType, RequestType } from 'common/actions/groups';

import requestReducerFactory, { type RequestState } from './requestReducerFactory';

import type { Group } from 'common/api/endpoints/group';

export type GroupsState = RequestState<Group[]>;

export default requestReducerFactory<Group[]>(RequestType, LoadedType, ErrorType);
